module.exports = __webpack_public_path__ + "img/signup-guide-02-01.d8cb3a51.png";